import { createSlice } from "@reduxjs/toolkit";
import {
  getVehicleType,
} from "./vehicleTypeService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  vehicleTypeList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const vehicleTypeSlice = createSlice({
  name: "vehicleType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get VehicleType List ---------- */
    builder
      .addCase(getVehicleType.pending, (state) => {
        state.vehicleTypeList.status = STATUS.LOADING;
        state.vehicleTypeList.error = null;
      })
      .addCase(getVehicleType.fulfilled, (state, action) => {
        state.vehicleTypeList.status = STATUS.SUCCEEDED;
        state.vehicleTypeList.data = action?.payload?.data || [];
      })
      .addCase(getVehicleType.rejected, (state, action) => {
        state.vehicleTypeList.status = STATUS.FAILED;
        state.vehicleTypeList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectVehicleTypeList = (state) =>
  state.vehicleType.vehicleTypeList;

export default vehicleTypeSlice.reducer;
